// extracted by mini-css-extract-plugin
export default {"container":"StarRating_container__luYUc","emptyStar":"StarRating_emptyStar__3wiC4","start":"StarRating_start__sPRlu"};